import { render } from "./TestcaseRun.vue?vue&type=template&id=2b057ee6"
import script from "./TestcaseRun.vue?vue&type=script&lang=js"
export * from "./TestcaseRun.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__